import styles from "../Checkbox.module.scss";

interface ILabelProps {
    /** The main label of the checkbox. */
    label: string;

    /** A sub-label displayed below the main label. */
    subLabel?: string;

    /** Whether the label component is disabled. */
    disabled?: boolean;
}

function Label({
    disabled,
    label,
    subLabel
}: Readonly<ILabelProps>): JSX.Element {
    return (
        <div className={styles.labelWrapper}>
            <p
                className={`${styles.textLabel} ${disabled ? styles.disabledLabel : ""}`}
            >
                {label}
            </p>
            {subLabel && (
                <p
                    className={`${styles.subTextLabel} ${disabled ? styles.disabledLabel : ""}`}
                >
                    {subLabel}
                </p>
            )}
        </div>
    );
}

export { Label };
